export default __webpack_public_path__ + "static/media/storyboard-thumbnail.00a457e3.svg";